import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "5 4 15 12 5 20 5 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "19", y1: "5", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SkipForward";
const SkipForward = memo(themed(Icon));
export {
  SkipForward
};
//# sourceMappingURL=skip-forward.js.map
